<template>
  <div class="init-page">
    <NuxtPage />
  </div>
</template>

<script setup lang="ts">
const equipment = useEquipmentStore();

/** 初始化登录配置 */
equipment.initSystemloginConfig();
</script>

<style scoped lang="scss">
.init-page {
  width: 100vw;
  min-height: 100vh;
}
</style>
